import { useQuery } from '@apollo/client/react';
import { BLOG_CATEGORIES_QUERY } from '../../graphql/blog-queries';

export default function useGetBlogCategories() {
    const { data, loading } = useQuery(BLOG_CATEGORIES_QUERY);
    return { data: data?.blogCategories, loading };
}
